import { defineMessages } from 'react-intl';

// We are not really using react-intl in this mini app.
// But here we are still defined them as react-intl format
// So the extraction job can send strings to the vendor to translate.
export const i18n = defineMessages({
	title: {
		id: 'error-app.title',
		defaultMessage: 'Something went wrong.',
		description: 'Head line of a screen shows "something went wrong" message',
	},
	subTitle: {
		id: 'error-app.sub-title',
		defaultMessage: 'We’re moving mountains to get it sorted.',
		description: 'Subtitle line of a screen shows a description under the title message',
	},
	detail: {
		id: 'error-app.detail',
		defaultMessage: 'View our {link} and subscribe for service updates.',
		description:
			'A link to a informational page on what may be causing the issue, the description is underneath the title and sub title',
	},
	linkName: {
		id: 'error-app.link-name',
		defaultMessage: 'status page',
		description:
			'The name to a link to a informational page on what may be causing the issue, the description is underneath the title and sub title',
	},
});
